import { render, staticRenderFns } from "./AccountOrders.vue?vue&type=template&id=60c7c6d3&scoped=true"
import script from "./AccountOrders.vue?vue&type=script&lang=ts"
export * from "./AccountOrders.vue?vue&type=script&lang=ts"
import style0 from "./AccountOrders.vue?vue&type=style&index=0&id=60c7c6d3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c7c6d3",
  null
  
)

export default component.exports